export {AnimatedProgress as default} from './AnimatedProgress';
